import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-workspace-user-picker",
  templateUrl: "./workspace-user-picker.component.html",
  styleUrls: ["./workspace-user-picker.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WorkspaceUserPickerComponent {}
